'use strict';

var ScheduleChangeToolbarController = function ScheduleChangeToolbarController() {};
ScheduleChangeToolbarController.$inject = [];
module.exports = ScheduleChangeToolbarController;